import * as extBech32 from "bech32";
import { Buffer } from "buffer";

export const bech32 = {
  encode(prefix: string, data: Buffer): string {
    return extBech32.bech32.encode(prefix, extBech32.bech32.toWords(data), 200);
  },
  decode(data: string, limit: number = 200): { prefix?: string; data: Buffer } {
    const decoded = extBech32.bech32.decode(data, limit);
    return {
      prefix: decoded.prefix,
      data: Buffer.from(extBech32.bech32.fromWords(decoded.words)),
    };
  },
};
